/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useState, useMemo } from 'react';
import { getCurrentFiltersValues } from '../../rmsReduxStore/reduxExports';
import './CustomNocMapFilters.css'
import { useAppDispatch } from '../../globalUtils/globalExports';
import { IconWithTooltip } from '../../globalUtils/globalIcons';

interface ICustomNocMapFiltersProps{
    filterHandler: any
}


const CustomNocMapFilters: React.FC<ICustomNocMapFiltersProps> = (props) => {
    const dispatch = useAppDispatch();
    const {filterHandler} = props
    const nocMapScreenFilters = getCurrentFiltersValues('nocDashboard', true);
    const [selectedViewLayers, setSelectedViewLayers] = useState<string[]>(nocMapScreenFilters?.[0]?.values)
    const [selectedChargerStatusFilters, setSelectedChargerStatusFilters] = useState(nocMapScreenFilters?.[1]?.values);
    const [selectedChargerRmsStatusFilters,setSelectedChargerRmsStatusFilters] = useState(nocMapScreenFilters?.[2]?.values?.[0]);
    const [selectedChargerCmsConnectivityFilters,setSelectedChargerCmsConnectivityFilters] = useState(nocMapScreenFilters?.[3]?.values?.[0]);
    const [selectedAlarmFilters, setSelectedAlarmFilters] = useState(nocMapScreenFilters?.[4]?.values);
    const [selectedChargingStatusFilters, setSelectedChargingStatusFilters] = useState(nocMapScreenFilters?.[5]?.values);
    const [selectedChargerNocAlarmHealthStatus,setSelectedChargerNocAlarmHealthStatus] = useState(nocMapScreenFilters?.[6]?.values?.[0]);
    const [selectedChargerHealthStatus,setSelectedChargerHealthStatus] = useState(nocMapScreenFilters?.[7]?.values);


    const handleBtnClick = async (label: string, value: string): Promise<void> => {
        let newSelectedValues: string[] = [];
        switch (label) {
            case 'mapDefaultView':
                if (selectedViewLayers?.includes(value)) {
                    newSelectedValues = selectedViewLayers?.filter(item => item !== value); 
                }
                else {
                    newSelectedValues = [...selectedViewLayers,value]
                }
                setSelectedViewLayers(newSelectedValues);
                break;
            case 'nocChargerStatus':
                if (selectedChargerStatusFilters?.includes(value)) {
                    newSelectedValues = selectedChargerStatusFilters?.filter(item => item !== value); 
                }
                else {
                    newSelectedValues = [...selectedChargerStatusFilters,value]
                }
                setSelectedChargerStatusFilters(newSelectedValues);
                break;
            case 'nocChargerRmsStatus': 
                newSelectedValues = value === '' ? [] : [value]
                setSelectedChargerRmsStatusFilters(value);
                break;
            case 'nocChargerCmsConnectivity':
                newSelectedValues = value === '' ? [] : [value]
                setSelectedChargerCmsConnectivityFilters(value);
                break;
            case 'nocChargerAlarms':
                if (selectedAlarmFilters?.includes(value)) {
                    newSelectedValues = selectedAlarmFilters?.filter(item => item !== value); 
                }
                else {
                    newSelectedValues = [...selectedAlarmFilters,value]
                }
                setSelectedAlarmFilters(newSelectedValues);
                break;
            case 'nocChargerChargingStatus':
                if (selectedChargingStatusFilters?.includes(value)) {
                    newSelectedValues = selectedChargingStatusFilters?.filter(item => item !== value); 
                }
                else {
                    newSelectedValues = [...selectedChargingStatusFilters,value]
                }
                setSelectedChargingStatusFilters(newSelectedValues);
                break;
            case 'nocAlarmHealthStatus':
                newSelectedValues = value === '' ? [] : [value]
                setSelectedChargerNocAlarmHealthStatus(value);
                break;
            case 'nocChargerHealthStatus':
                 if (selectedChargerHealthStatus?.includes(value)) {
                    newSelectedValues = selectedChargerHealthStatus?.filter(item => item !== value); 
                }
                else {
                    newSelectedValues = [...selectedChargerHealthStatus,value]
                }
                setSelectedChargerHealthStatus(newSelectedValues);
                break;
            default:
                return;
        }
        const data = newSelectedValues?.map(item => ({ id: item, label: item, value: item, name: item }));
        filterHandler(data,label)
    }


    const viewLayerFilterButtons = useMemo(() => [
        {
            buttonId: 'chargingSessions',
            buttonClassName: selectedViewLayers?.includes('chargingSessions') ? 'custom__noc__map__filter-btn-selected' : 'custom__noc__map__filter-btn',
            buttonIcon: selectedViewLayers?.includes('chargingSessions') ? 'custom__noc__map__view__layer__charging-session-btn-icon-selected' : 'custom__noc__map__view__layer__charging-session-btn-icon',
            handleClick: () => { handleBtnClick('mapDefaultView', 'chargingSessions') },
            toolTipText:'Charging Session'
        },
        {
            buttonId: 'disableCluster',
            buttonClassName: selectedViewLayers?.includes('disableCluster')?'custom__noc__map__filter-btn' : 'custom__noc__map__filter-btn-selected' ,
            buttonIcon: selectedViewLayers?.includes('disableCluster') ? 'custom__noc__map__view__layer__disable-cluster-btn-icon':'custom__noc__map__view__layer__disable-cluster-btn-icon-selected',
            handleClick: () => { handleBtnClick('mapDefaultView', 'disableCluster') },
            toolTipText: 'Cluster'
        }
    ], [selectedViewLayers])

    const connectivityFilterButtons = useMemo(()=>[
        {
            buttonId: 'online',
            buttonClassName: selectedChargerStatusFilters?.includes('Online') ? 'custom__noc__map__filter-btn-selected' : 'custom__noc__map__filter-btn',
            buttonIcon: selectedChargerStatusFilters?.includes('Online') ? 'custom__noc__map__connectivity__online-btn-icon-selected' : 'custom__noc__map__connectivity__online-btn-icon',
            handleClick: () => { handleBtnClick('nocChargerStatus', 'Online') },
            toolTipText: 'Online Chargers'
        },
        {
            buttonId: 'offline',
            buttonClassName: selectedChargerStatusFilters?.includes('Offline') ? 'custom__noc__map__filter-btn-selected' : 'custom__noc__map__filter-btn',
            buttonIcon: selectedChargerStatusFilters?.includes('Offline') ? 'custom__noc__map__connectivity__offline-btn-icon-selected' : 'custom__noc__map__connectivity__offline-btn-icon',
            handleClick: () => { handleBtnClick('nocChargerStatus', 'Offline') },
            toolTipText: 'Offline Chargers'
        },
        {
            buttonId: 'rmsDisable',
            buttonClassName: selectedChargerRmsStatusFilters === 'Disable' ? 'custom__noc__map__filter-btn-selected' : 'custom__noc__map__filter-btn',
            buttonIcon: selectedChargerRmsStatusFilters === 'Disable' ? 'custom__noc__map__connectivity__rms-disable-btn-icon-selected' : 'custom__noc__map__connectivity__rms-disable-btn-icon',
            handleClick: () => { 
                const value =selectedChargerRmsStatusFilters === 'Disable' ? '' : 'Disable'
                handleBtnClick('nocChargerRmsStatus', value) 
            },
            toolTipText:'RMS Disabled'
        },
        {
            buttonId: 'cmsFail',
            buttonClassName: selectedChargerCmsConnectivityFilters === 'Fail' ? 'custom__noc__map__filter-btn-selected': 'custom__noc__map__filter-btn',
            buttonIcon: selectedChargerCmsConnectivityFilters === 'Fail' ? 'custom__noc__map__connectivity__cms-fail-btn-icon-selected' : 'custom__noc__map__connectivity__cms-fail-btn-icon',
            handleClick: () => { 
                const value = selectedChargerCmsConnectivityFilters === 'Fail' ? '' : 'Fail'
                handleBtnClick('nocChargerCmsConnectivity', value) 
             },
            toolTipText:'CMS Disabled'
        },
    ],[selectedChargerStatusFilters,selectedChargerRmsStatusFilters,selectedChargerCmsConnectivityFilters])


    const AlarmFilterButtons = useMemo(()=>[
        {
            buttonId: 'critical',
            buttonClassName: selectedAlarmFilters?.includes('critical') ? 'custom__noc__map__filter-btn-selected custom__noc__map__alarms__critical-alarm-selected' : 'custom__noc__map__filter-btn',
            buttonIcon: selectedAlarmFilters?.includes('critical') ? 'custom__noc__map__alarms__critical-alarm-btn-icon-selected' : 'custom__noc__map__alarms__critical-alarm-btn-icon',
            handleClick: () => { handleBtnClick('nocChargerAlarms', 'critical') },
            toolTipText:'Critical Alarms'
        },
        {
            buttonId: 'major',
            buttonClassName: selectedAlarmFilters?.includes('major') ? 'custom__noc__map__filter-btn-selected custom__noc__map__alarms__major-alarm-selected' : 'custom__noc__map__filter-btn',
            buttonIcon: selectedAlarmFilters?.includes('major') ? 'custom__noc__map__alarms__major-alarm-btn-icon-selected' : 'custom__noc__map__alarms__major-alarm-btn-icon',
            handleClick: () => { handleBtnClick('nocChargerAlarms', 'major') },
            toolTipText:'Major Alarms'
        },
        {
            buttonId: 'minor',
            buttonClassName: selectedAlarmFilters?.includes('minor') ? 'custom__noc__map__filter-btn-selected custom__noc__map__alarms__minor-alarm-selected' : 'custom__noc__map__filter-btn',
            buttonIcon: selectedAlarmFilters?.includes('minor') ? 'custom__noc__map__alarms__minor-alarm-btn-icon-selected' : 'custom__noc__map__alarms__minor-alarm-btn-icon',
            handleClick: () => { handleBtnClick('nocChargerAlarms', 'minor') },
            toolTipText: 'Minor Alarms'
        }
    ],[selectedAlarmFilters])

    const ChargingStatusFilterButtons = useMemo(()=>[
        {
            buttonId: 'active',
            buttonClassName: selectedChargingStatusFilters?.includes('active') ? 'custom__noc__map__filter-btn-selected' : 'custom__noc__map__filter-btn',
            buttonIcon: selectedChargingStatusFilters?.includes('active') ? 'custom__noc__map__charging-status-active-btn-icon-selected' : 'custom__noc__map__charging-status-active-btn-icon',
            handleClick: () => { handleBtnClick('nocChargerChargingStatus', 'active') },
            toolTipText: 'Active Charging Session'
        },
        {
            buttonId: 'inactive',
            buttonClassName: selectedChargingStatusFilters?.includes('inactive') ? 'custom__noc__map__filter-btn-selected' : 'custom__noc__map__filter-btn',
            buttonIcon: selectedChargingStatusFilters?.includes('inactive') ? 'custom__noc__map__charging-status-inactive-btn-icon-selected' : 'custom__noc__map__charging-status-inactive-btn-icon',
            handleClick: () => { handleBtnClick('nocChargerChargingStatus', 'inactive') },
            toolTipText: 'Idle Charging Session'
        },
    ],[selectedChargingStatusFilters])


    const chargerHealthStatusFilterButtons = useMemo(()=>[
        {
            buttonId: 'nocAlarmHealthStatus',
            buttonClassName: selectedChargerNocAlarmHealthStatus === 'Chronic'  ? 'custom__noc__map__filter-btn-selected custom__noc__map__chronic__alarm__btn-selected' : 'custom__noc__map__filter-btn',
            buttonIcon: selectedChargerNocAlarmHealthStatus === 'Chronic'   ? 'custom__noc__map__charger__noc__alarm__health__status-icon-selected' : 'custom__noc__map__charger__noc__alarm__health__status-icon',
            handleClick: () => { 
                const value = selectedChargerNocAlarmHealthStatus === 'Chronic' ? '' : 'Chronic'
                handleBtnClick('nocAlarmHealthStatus', value) 
            },
            toolTipText: 'Chronic Alarms'
        },
        {
            buttonId: 'healthyChargers',
            buttonClassName: selectedChargerHealthStatus?.includes('Healthy') ? 'custom__noc__map__filter-btn-selected custom__noc__map__healthy__chargers_btn-selected' : 'custom__noc__map__filter-btn',
            buttonIcon: selectedChargerHealthStatus?.includes('Healthy') ? 'custom__noc__map__healthy-charger-icon-selected' : 'custom__noc__map__healthy-charger-icon',
            handleClick: () => { handleBtnClick('nocChargerHealthStatus', 'Healthy') },
            toolTipText: 'Healthy Chargers'
        },
        {
            buttonId: 'faultyChargers',
            buttonClassName: selectedChargerHealthStatus?.includes('Faulty') ? 'custom__noc__map__filter-btn-selected custom__noc__map__faulty__chargers_btn-selected' : 'custom__noc__map__filter-btn',
            buttonIcon: selectedChargerHealthStatus?.includes('Faulty') ? 'custom__noc__map__faulty-charger-icon-selected' : 'custom__noc__map__faulty-charger-icon',
            handleClick: () => { handleBtnClick('nocChargerHealthStatus', 'Faulty') },
            toolTipText: 'Faulty Chargers'
        },
        

    ],[selectedChargerNocAlarmHealthStatus,selectedChargerHealthStatus])

    const NocMapFilterProps = [
        {
            id: 'viewLayerFitlers',
            header: 'Layers',
            btns: viewLayerFilterButtons
        },
        {
            id:'connectivity',
            header: 'Connectivity',
            btns: connectivityFilterButtons,
        },
        {
            id: 'alarms',
            header: 'Alarms',
            btns: AlarmFilterButtons
        },
        {
            id:'chargingStatus',
            header: 'Charging',
            btns: ChargingStatusFilterButtons
        },
        {
            id:'chargerHealthStatus',
            header: 'Derived Status',
            btns: chargerHealthStatusFilterButtons
        }
    ]

    return (
        <div className='custom__noc__map__filters-container'>
            {
                NocMapFilterProps?.map((filter) => {
                    return (
                        <div key={filter?.id} className='custom__noc__map__view__layers-filter-container'>
                            <div className='custom__noc__map__filter-container-label'>{filter?.header}</div>
                            <div className='custom__noc__map__filter-btns-container'>
                                {filter?.btns?.map(btn => {
                                    return (
                                        <div key={btn?.buttonId} onClick={btn?.handleClick} className={btn?.buttonClassName}>
                                            <IconWithTooltip iconClassName={btn?.buttonIcon} toolTipText={btn?.toolTipText} containerClassName={'custom__noc__map__filter__btn__icon__container'}/>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}


export default CustomNocMapFilters